<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import { useScreenSize } from '@/utils/media';

const route = useRoute();
const { isLg } = useScreenSize();

// Patientページでモバイル時はタブバー分の余白を追加
const mainClass = computed(() => {
  const isPatientPage = route.path.startsWith('/user/');
  const noTabBarRoutes = [
    '/user/login',
    '/user/register',
    '/user/sign-up',
    '/user/reset-password',
  ];
  const isNoTabBar = noTabBarRoutes.some((path) => route.path.startsWith(path));

  // モバイルかつPatientページで、タブバー非表示対象ルートでなければ余白追加
  if (isPatientPage && !isLg.value && !isNoTabBar) {
    return 'flex-1 pb-20';
  }
  return 'flex-1';
});
</script>

<template>
  <div class="md:overflow-x-hidden min-h-screen flex flex-col">
    <RouterView name="Header" />
    <main :class="mainClass">
      <RouterView />
    </main>
    <RouterView name="Footer" />
  </div>
</template>
